import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const FormHistoryMobileStyle = {
  wrapper: css`
    h4 {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: white;

      margin-bottom: 8px;
    }
  `,

  inputGroup: css`
    text-align: center;
    color: ${theme.colors.white};
    .ant-picker {
      width: 100%;
      padding: 0.25rem 0.5rem;
      color: #555;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
  `,
  selectGroup: css`
    display: flex;
    flex-direction: column;

    label {
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      color: ${theme.colors.white};

      padding: 8px 0;
    }
    select {
      width: 100%;
      padding: 0.25rem 0.5rem;
      color: #555;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
  `,
  checkBoxGroup: css`
    margin: 8px 0;

    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: white;
      margin-left: 5px;
    }
  `,

  btnGroup: css`
    text-align: center;

    margin-bottom: 16px;
    button {
      background-color: ${theme.colors.orange[200]} !important;
      color: white !important;

      width: 73.74px;
      height: 36px;
    }
  `,
};
